import { render, staticRenderFns } from "./ProductsPriceTotal.vue?vue&type=template&id=885bfb20&scoped=true&"
import script from "./ProductsPriceTotal.vue?vue&type=script&lang=js&"
export * from "./ProductsPriceTotal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPriceTotal.vue?vue&type=style&index=0&id=885bfb20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885bfb20",
  null
  
)

export default component.exports